import { ACTION, track as trackOrig, TrackingConfig } from '@gd/tracking'
import { store } from '@/store'
import packageJSON from '../../package.json'

const { version } = packageJSON

interface TrackOptions {
  id?: string
  elem?: string
  action?: ACTION
  data?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

interface TrackOptionsOrig extends TrackOptions {
  key: string
}

/**
 * extends the track call with version and platform parameter
 */
const track = (conf?: TrackOptions, options?: TrackingConfig) => {
  const opt = { ...options, stealthy: true }
  conf.key = 'tournaments'
  conf.app_version = version
  return trackOrig(conf as TrackOptionsOrig, opt)
}
export { track }
